<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div>
  <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Select
    POAM {{isLink ? 'to Link' : 'to Copy'}}</h2>
  <mat-dialog-content>
    <p-table [value]="actionPlanTemplates"
             [rows]="100"
             [paginator]="false"
             [style]="{'margin-top':'10px'}"
             [resizableColumns]="true"
             [reorderableColumns]="true"
             dataKey="category"
             #dashboardTable>

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 5em;"></th>
          <th>
            Category
          </th>
          <th>
            Name
          </th>
          <th>
            Type
          </th>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded" let-columns="columns">
        <tr class="ui-widget-header" *ngIf="rowGroupMetadata[item.category || ' '].index === rowIndex">
          <td colspan="4">
            <a href="#" [pRowToggler]="item">
              <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              <span>{{item.category}}</span>
            </a>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-rowData let-expanded="expanded" let-columns="columns">
        <tr>
          <td>
                    <span>
                      <i [ngClass]="rowData.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         (click)="rowData.open = !rowData.open"></i>
                    </span>
          </td>
          <td (click)="selectActionPlanTemplate(rowData)">
            {{rowData.category}}
          </td>
          <td (click)="selectActionPlanTemplate(rowData)">
            {{rowData.name}}
          </td>
          <td>
            {{rowData.projectId ? "Local" : "Global"}}
          </td>
        </tr>
        <tr *ngIf="rowData.open">
          <td colspan="3" (click)="selectActionPlanTemplate(rowData)">
            <span style="font-weight: bold;">Weakness Description:</span>
            {{rowData.weaknessDescription}}
            <span style="font-weight: bold;margin-top: 10px;">How Identified:</span>
            {{rowData.howIdentified}}
            <span style="font-weight: bold;margin-top: 10px;">Risk Level:</span>
            {{rowData.riskLevel}}
          </td>
        </tr>
      </ng-template>


    </p-table>
  </mat-dialog-content>
</div>
